import '../../styles/receipts.scss';

window.slate = window.slate || {};
window.theme = window.theme || {};
window.Jbhifi = window.Jbhifi || {};

window.Jbhifi.isProd = process.env.NODE_ENV === 'production';